/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Preview_More_Blocks_SuffixInputs */

const en_plain_text_import_preview_more_blocks_suffix = /** @type {(inputs: Plain_Text_Import_Preview_More_Blocks_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`more blocks not shown`)
};

const fr_plain_text_import_preview_more_blocks_suffix = /** @type {(inputs: Plain_Text_Import_Preview_More_Blocks_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`blocs supplementaires non affiches`)
};

const de_plain_text_import_preview_more_blocks_suffix = /** @type {(inputs: Plain_Text_Import_Preview_More_Blocks_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Blöcke werden nicht angezeigt`)
};

const it_plain_text_import_preview_more_blocks_suffix = /** @type {(inputs: Plain_Text_Import_Preview_More_Blocks_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`altri blocchi non mostrati`)
};

const ru_plain_text_import_preview_more_blocks_suffix = /** @type {(inputs: Plain_Text_Import_Preview_More_Blocks_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`больше блоков не показано`)
};

const es_plain_text_import_preview_more_blocks_suffix = /** @type {(inputs: Plain_Text_Import_Preview_More_Blocks_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`más bloques no mostrados`)
};

const zh_cn2_plain_text_import_preview_more_blocks_suffix = /** @type {(inputs: Plain_Text_Import_Preview_More_Blocks_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更多未显示的方块`)
};

const ja_plain_text_import_preview_more_blocks_suffix = /** @type {(inputs: Plain_Text_Import_Preview_More_Blocks_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他のブロックは表示されません`)
};

const hi_plain_text_import_preview_more_blocks_suffix = /** @type {(inputs: Plain_Text_Import_Preview_More_Blocks_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`और ब्लॉक नहीं दिखाए गए`)
};

const pt_pt2_plain_text_import_preview_more_blocks_suffix = /** @type {(inputs: Plain_Text_Import_Preview_More_Blocks_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais blocos não exibidos`)
};

/**
* | output |
* | --- |
* | "more blocks not shown" |
*
* @param {Plain_Text_Import_Preview_More_Blocks_SuffixInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_preview_more_blocks_suffix = /** @type {((inputs?: Plain_Text_Import_Preview_More_Blocks_SuffixInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Preview_More_Blocks_SuffixInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_preview_more_blocks_suffix(inputs)
	if (locale === "de") return de_plain_text_import_preview_more_blocks_suffix(inputs)
	if (locale === "it") return it_plain_text_import_preview_more_blocks_suffix(inputs)
	if (locale === "ru") return ru_plain_text_import_preview_more_blocks_suffix(inputs)
	if (locale === "es") return es_plain_text_import_preview_more_blocks_suffix(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_preview_more_blocks_suffix(inputs)
	if (locale === "ja") return ja_plain_text_import_preview_more_blocks_suffix(inputs)
	if (locale === "hi") return hi_plain_text_import_preview_more_blocks_suffix(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_preview_more_blocks_suffix(inputs)
	return en_plain_text_import_preview_more_blocks_suffix(inputs)
});